import i18n from "@/i18n"

export default {
  path: "/support",
  component: () => import("./index.vue"),
  name: "support",
  meta: {
    title: "support.title"
  }
}
